/**
 * Custom Fields API client — typed functions for field definitions and entity metadata.
 */
import { apiClient } from './index';

export interface FieldDefinition {
  id: string;
  tenant_id: string;
  entity_type_id: string;
  name: string;
  key: string;
  field_type: 'text' | 'number' | 'date' | 'boolean' | 'select' | 'url';
  options: string[]; // for select type
  required: boolean;
  position: number;
  created_at: string;
}

export async function listFieldDefinitions(entityTypeId: string): Promise<FieldDefinition[]> {
  const { data } = await apiClient.get<{ data: FieldDefinition[] }>(
    `/entity-types/${entityTypeId}/fields`,
  );
  return data.data ?? [];
}

export async function createFieldDefinition(
  entityTypeId: string,
  input: Partial<FieldDefinition>,
): Promise<FieldDefinition> {
  const { data } = await apiClient.post<FieldDefinition>(
    `/entity-types/${entityTypeId}/fields`,
    input,
  );
  return data;
}

export async function updateFieldDefinition(
  entityTypeId: string,
  fieldId: string,
  input: Partial<FieldDefinition>,
): Promise<FieldDefinition> {
  const { data } = await apiClient.put<FieldDefinition>(
    `/entity-types/${entityTypeId}/fields/${fieldId}`,
    input,
  );
  return data;
}

export async function deleteFieldDefinition(
  entityTypeId: string,
  fieldId: string,
): Promise<void> {
  await apiClient.delete(`/entity-types/${entityTypeId}/fields/${fieldId}`);
}

export async function patchEntityMetadata(
  entityId: string,
  patch: Record<string, unknown>,
): Promise<void> {
  await apiClient.patch(`/entities/${entityId}/metadata`, patch);
}
